<template>
  <div v-if="requisitionOuts && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <MutiplePiecesPrint
      :showSinglePrint="!printPreviewMode"
      :formater="formater"
      :datas="requisitionOuts"
    />
  </div>
</template>
<script>
import StockOuts from "@/api/stock_outs";
import PrintTemplates from "@/api/print_templates";
import MutiplePiecesPrint from "@/components/plugins/print/MutiplePiecesPrint";
// import makeData from "./makeData";

export default {
  components: {
    MutiplePiecesPrint,
  },

  data: () => ({
    formater: null,
    requisitionOuts: [],
    printPreviewMode: false
  }),

  mounted() {
    PrintTemplates.fetchOne("requisitionMergeStockOrderOut").then(
      function (response) {
        if (response.data.status.isOK()) {
          let formater = response.data.print_template.template;
          this.formater = formater;
          //获取单据详情
          var options = JSON.parse(JSON.stringify(this.$route.query));
          if (options.status && options.status.find((s) => s == 1))
            options.status.splice(
              options.status.findIndex((s) => s == 1),
              1
            );
          if (this.$route.path === '/print/requisition-out-merge-print-preview') {
            options.disable_print_count = 1;
            this.printPreviewMode = true
          }
          StockOuts.requisitionOutMergePrint(options).then(
            function (response) {
              if (response.data.status.isOK()) {
                // let requisitionOuts = [];
                // response.data.stock_outs.forEach((stock_out) => {
                //   stock_out.shop = this.$printUtils.addCitiesName(
                //     stock_out.shop
                //   );
                  // requisitionOuts.push(makeData.processDetails(stock_out));
                // });
                this.requisitionOuts = response.data.stock_outs;
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>